import { render } from "./Marketing.vue?vue&type=template&id=7c541d67&scoped=true"
import script from "./Marketing.vue?vue&type=script&lang=js"
export * from "./Marketing.vue?vue&type=script&lang=js"

import "./Marketing.vue?vue&type=style&index=0&id=7c541d67&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c541d67"]])

export default __exports__